import { memo, useMemo } from 'react'
import { useLayout } from '@/context/layout-provider'
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar'
import { useAuthStore, useUser } from '@/features/auth'
import { useUnreadMessageCount } from '@/features/messages/hooks/useUnreadMessageCount'
import { SessionsNav } from '@/features/sessions'
import { AppTopBar } from './app-top-bar'
// import { AppTitle } from './app-title'
import { sidebarData } from './data/sidebar-data'
import { NavGroup } from './nav-group'

export const AppSidebar = memo(() => {
  const { collapsible, variant } = useLayout()
  const { user } = useAuthStore((s) => s.auth)
  useUser() // 在 layout 层触发 profile 拉取，确保 auth.user.role 在侧边栏初始渲染后立即可用
  const unreadCount = useUnreadMessageCount()

  const filteredNavGroups = useMemo(() => {
    return sidebarData.navGroups
      .filter((group) => {
        if (!group.roles || group.roles.length === 0) return true
        return user?.role && group.roles.includes(user.role)
      })
      .map((group) => ({
        ...group,
        items: group.items.map((item) =>
          'url' in item && item.url === '/messages'
            ? { ...item, badge: unreadCount > 0 ? String(unreadCount) : undefined }
            : item
        ),
      }))
  }, [user, unreadCount])
  return (
    <Sidebar collapsible={collapsible} variant={variant}>
      <SidebarHeader>
        <AppTopBar />
      </SidebarHeader>
      <SidebarContent>
        {filteredNavGroups.map((props) => {
          return <NavGroup key={props.title} {...props} />
        })}
        {/* 足迹 - 会话列表 */}
        <SessionsNav />
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  )
})
